import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import ImageLoad from 'components/ImageLoad';
import queryString from 'query-string';
import CmsService from "services/CMS/";
import CMSFactory from "factories/CMS";
import TagManagerService from 'services/TagManager';
import { useIsMounted } from 'hooks';
import PubSub from 'services/PubSub';
import style from './style.scss';//NOSONAR

let actions = [];
let visibilityShortcuts = true;

const Shortcuts = ({ location }) => {
    const isMounted = useIsMounted();
    const [shortcuts, setShortcuts] = useState()
    const [isWithImage, setIsWithImage] = useState()
    const [isActive, setIsActive] = useState(false)

    useEffect(() => {

        actions.push(PubSub.register('shortcuts_hidden', shortcutsHidden));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
            visibilityShortcuts = true;
        }
    }, [])

    useEffect(() => {

        const _shorcuts = shortcuts && {...shortcuts};

        if (_shorcuts && _shorcuts.items && _shorcuts.items.length >= 3){

            if(_shorcuts.items.length > 6){
                _shorcuts.items = _shorcuts.items.slice(0,6);
                setShortcuts(_shorcuts);
            }
            
            setIsActive(true)
            for (let item of _shorcuts.items) {
                if (!item.image) {
                    setIsWithImage(false)
                    break
                }
                setIsWithImage(true)
            }
            
        }
    }, [shortcuts])

    useEffect(() => {
        const items = shortcuts && shortcuts.items
        if(items){
            items.map((item, index) => {
                const gtmData = ({
                    url_banner: item.url,
                    id: `PLP - ${item.image ? item.image.split('/').pop() : item.text}`,
                    name: `PLP - ${location.pathname}`,
                    creative: `Shortcut - ${item.text}`,
                    position: `slot${index +1}`,
                })
                TagManagerService.promotionsImpressions([gtmData]);
                item.gtmData = gtmData;
            })
        }
    }, [shortcuts])

    useEffect(() => {
        if(!visibilityShortcuts) {
            setIsActive(false);
        }
    }, [visibilityShortcuts])

    const shortcutsHidden = (payload) => {
        if(payload.value === true) {
            setIsActive(false);
            visibilityShortcuts = false;
        }
        getShortcutsContent();
    }

    const getShortcutsContent = () => {
        const pathname = location.pathname ? location.pathname.replace('/', '').split('/').filter(Boolean).pop() : '';
        if(!pathname) return false;
        let consults = [];

        if (pathname === 'busca') {
            const searchParams = queryString.parse(location.search);
            const collection = searchParams.fq ? searchParams.fq.replace('H:','') : '';

            if(collection){
                consults.push(CmsService.getPLP(collection, 'collection'))
            }

        } else {
            consults.push(CmsService.getPLP(pathname, 'category'))
        }

        consults.push(CmsService.getDateTime());

        Promise.all(consults).then(response => {
            if(!isMounted) return false;

            const dateTime = (response && response[1]) ? response[1].datetime : '';
            const shortcutsRes = (response && response[0]) ? response[0] : [];
            const serverDate = dateTime ? CMSFactory.milliseconds(dateTime) : '';
            
            if (shortcutsRes && shortcutsRes.acf && shortcutsRes.acf.shortcuts) {
                const sc = shortcutsRes.acf.shortcuts

                const startDate = (sc.start_date) ? CMSFactory.milliseconds(sc.start_date) : '';
                const endDate = (sc.end_date) ? CMSFactory.milliseconds(sc.end_date) : '';
                let validDates = true;

                if (startDate && startDate >= serverDate) validDates = false;
                if (endDate && serverDate >= endDate) validDates = false;

                if (validDates && sc.active && visibilityShortcuts) {
                    sc.items = sc.items.filter(item => item.active && item.text);

                    setShortcuts(sc);

                } else {
                    setShortcuts(null);
                }
            }
        });
    }

    const clickShortcut = (item) => {
        TagManagerService.promotionsClick(item.gtmData, item.gtmData.position, item.gtmData.creative);
    }

    if (!isActive || !(shortcuts && shortcuts.items && shortcuts.items.length)) return '';

    return (
        <div className={`shortcuts ${isWithImage ? 'with-image' : ''} ${shortcuts.dark_mode && isWithImage ? 'dark' : ''}`}>
            {shortcuts.items.map((item, index) => {
                const validateText = item.text.length > 0;
                return (
                    (validateText) ? (
                        <Link to={item.url} onClick={() => clickShortcut(item)} className="shortcuts-item" key={index} target={item.target}>
                            {isWithImage ? <ImageLoad src={item.image} alt={item.text}/> : ''}
                            <div className="shortcuts-text-box">
                                <p className="shortcuts-text">{item.text}</p>
                            </div>
                        </Link>
                    ) : ''
                )})}
        </div>
    )
}

Shortcuts.propTypes = {
    location: PropTypes.object,
}

export default Shortcuts
